export const UNIT_LIST = [
  "Bags",
  "bag",
  "Baskets",
  "basket",
  "Paint bucket",
  "½ Paint bucket",
  "Derica (tomato tin)",
  "Pieces",
  "piece",
  "pack",
  "dozen",
  "Bunch",
  "Module",
  "Hand",
  "Crate",
  "Half Crate",
  "Dustbin Basket",
  "Half Dustbin Basket",
  "kg",
  "Kilograms (kg)",
  "2kg",
  "2.5kg",
  "3kg",
  "4kg",
  "5kg",
  "10kg",
  "15kg",
  "25kg",
  "50kg",
  "g",
  "Pounds (lbs)",
  "liter",
  "Litre (L)",
  "1.5 litre",
  "2 litre",
  "2.5 litre",
  "3 litre",
  "4.5 litre",
  "5 litre",
  "10 litres",
  "15 litres",
  "25 litres",
  "Centiliters (CL)",
  "ml",
] as const;

export const UNIT_OPTIONS = UNIT_LIST.map((unit) => ({
  label: unit === "Bags" ? "Bag" : unit,
  value: unit,
}));

export const ALLOWED_UNITS = new Set<string>([
  ...UNIT_LIST,
  ...UNIT_LIST.map((unit) => unit.toLowerCase()),
  "kg",
  "g",
  "liter",
  "ml",
  "piece",
  "dozen",
  "pack",
  "bag",
  "basket",
  "bunch",
  "module",
  "hand",
  "half dustbin basket",
  "crate",
  "half crate",
  "dustbin basket",
  "Bunch",
  "Module",
  "Hand",
  "Half Dustbin Basket",
  "Crate",
  "Half Crate",
  "Dustbin Basket",
]);
